import Vue from 'vue'
import VueRouter from 'vue-router'

// 首页 入口
const Home = () => import('../views/Home.vue')
// 授权登录页
const Login = () => import('@/views/login')

// 报刊亭
const TabsEntry = () => import('../views/newsKiosk')
// 报刊
const NewspapersAndPeriodicals = () => import('../views/newsKiosk/newspapersAndPeriodicals')
const NewspapersAndPeriodicalsList = () => import('../views/newsKiosk/newspapersAndPeriodicals/list')
// 图书
const Books = () => import('../views/newsKiosk/books')
const BooksList = () => import('../views/newsKiosk/books/list.vue')
// 文创
const CulturalCreation = () => import('../views/newsKiosk/culturalCreation')
const CulturalCreationList = () => import('../views/newsKiosk/culturalCreation/list')
// 立即订阅 订阅详情
const SubscribeDetail = () => import('../views/newsKiosk/subscribe/subscribeDetail.vue')
// 提交订单
const SubmitOrder = () => import('../views/newsKiosk/subscribe/submitOrder.vue')

// 服务台
const Reception = () => import('../views/reception')
// 用户中心
const UserCentered = () => import('../views/reception/userCentered')
// 查看订单页面
const OrderDetail = () => import('../views/reception/userCentered/OrderDetail')
// 用户反馈
const UserComplaints = () => import('../views/reception/userComplaints')

//解决重复点菜单报红问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/newsKiosk',
    children: [
      {
        path: 'newsKiosk',
        name: 'Entry',
        component: TabsEntry,
        redirect: { name: 'NewspapersAndPeriodicals' },
        children: [
          {
            path: 'newspapersandperiodicals',
            name: 'NewspapersAndPeriodicals',
            component: NewspapersAndPeriodicals,
            redirect: { name: 'NewspapersAndPeriodicalsList' },
            children: [
              {
                path: 'list',
                name: 'NewspapersAndPeriodicalsList',
                component: NewspapersAndPeriodicalsList
              }
            ]
          },
          {
            path: 'books',
            name: 'Books',
            component: Books,
            redirect: { name: 'BooksList' },
            children: [
              {
                path: 'list',
                name: 'BooksList',
                component: NewspapersAndPeriodicalsList
              }
            ]
          },
          {
            path: 'culturalCreation',
            name: 'CulturalCreation',
            component: CulturalCreation,
            redirect: { name: 'CulturalCreationList' },
            children: [
              {
                path: 'list',
                name: 'CulturalCreationList',
                component: NewspapersAndPeriodicalsList
              }
            ]
          }
        ]
      },
      {
        path: 'reception',
        name: 'Reception',
        component: Reception,
        redirect: { name: 'UserCentered' },
        children: [
          {
            path: 'userCentered',
            name: 'UserCentered',
            component: UserCentered
          },
          {
            path: 'orderDetail',
            name: 'OrderDetail',
            component: OrderDetail
          },
          {
            path: 'userComplaints',
            name: 'UserComplaints',
            component: UserComplaints
          }
        ]
      },
      {
        path: 'subscribeDetail',
        name: 'SubscribeDetail',
        component: SubscribeDetail
      },
      {
        path: 'submitOrder',
        name: 'SubmitOrder',
        component: SubmitOrder
      },
      {
        path: 'login',
        name: 'Login',
        component: Login
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (process.env.NODE_ENV === 'localdevelopment') {
    next()
    return
  }
  let userInfo = window.sessionStorage.getItem('userInfo')
  if (to.name === 'Login') {
    next()
  } else {
    if (userInfo) {
      next()
    } else {
      window.sessionStorage.setItem('query', JSON.stringify(to.query))
      next({ name: 'Login', query: { redirect_url: to.name } })
    }
  }
})

export default router
